:host {
  display: flex;
  width: 100%;
  height: var(--omk-divider-thickness, var(--omk-dimension-border-width-normal));
  box-sizing: border-box;
  --_omk-divider-background: var(--omk-divider-background, var(--omk-colour-border-primary-resting));
  --_omk-divider-inset: var(--omk-divider-inset, var(--omk-dimension-spacing-small));
  --_omk-divider-border-radius-rounded: var(--omk-divider-border-radius-rounded, var(--omk-dimension-border-radius-full));
  --_omk-divider-border-radius-default: var(--omk-divider-border-radius-default, 0);
}

:host([inset]),
:host([inset-start]) {
  padding-inline-start: var(--_omk-divider-inset);
}
:host([inset]),
:host([inset-end]) {
  padding-inline-end: var(--_omk-divider-inset);
}
:host::before {
  content: '';
  width: 100%;
  height: 100%;
  background: var(--_omk-divider-background);
  border-radius: var(--_omk-divider-border-radius-default);
}

:host([rounded])::before {
  border-radius: var(--_omk-divider-border-radius-rounded);
}
